import { isMockEnabled } from "@/lib/mock-flags";
import * as mock from "../mocks/fixtures";
import * as real from "./real";
import type { ListMyPaymentsParams, MySubscription, PagedPayments } from "../mocks/fixtures";

function pick() {
  return isMockEnabled("subscription") ? mock : real;
}

export function getMySubscription(): Promise<MySubscription> {
  return pick().getMySubscription();
}

export function listMyPayments(params?: ListMyPaymentsParams): Promise<PagedPayments> {
  return pick().listMyPayments(params);
}

export { deriveStatus } from "../mocks/fixtures";

export type {
  BillingCycle,
  BoletoDetails,
  CardDetails,
  DefaultPaymentMethod,
  DerivedPaymentStatus,
  ListMyPaymentsParams,
  MyPayment,
  MySubscription,
  MySubscriptionPlan,
  NextInvoice,
  PagedPayments,
  PaymentMethod,
  PaymentStatus,
  PaymentStatusFilter,
  PixDetails,
  SubscriptionGrant,
  SubscriptionOrigin,
  SubscriptionStatus,
} from "../mocks/fixtures";
